import {AppConfig} from 'appConfig';
import {defaultsDeep} from 'lodash-es';
import {SignUpFlow} from '../enums/sign-up-flow';
import defaultConfig from './default';
import hgCommonConfig from './hg-common';

const appConfigPartial: Partial<AppConfig> = {
    applicationTitle: 'GO Terminal',

    api: {
        root: '',

        imageUpload: 'api/v1/image'
    },

    signUpFlow:        SignUpFlow.CLOSED,
    resetPasswordFlow: false,

    signUpUrl: null, // Clear in order to use internal sign-up URL.

    logoImageUrl:           'images/go-logo.svg',
    backofficeLogoImageUrl: 'images/go-logo.svg',
    loginLogoImageUrl:      'images/go-login-logo.svg',

    canClientUpdateExchangeAccountKeys: true,

    defaultWatchlistId: defaultConfig.predefinedWatchlistIds['BINANCE']
};

export const goCommonConfig: AppConfig = defaultsDeep(appConfigPartial, hgCommonConfig);
export default goCommonConfig;
